/**
 * Configuration based on environment
 *
 * This file exports the appropriate configuration based on the REACT_APP_API_ENV value:
 * - When REACT_APP_API_ENV=production: Uses production API endpoints
 * - Otherwise: Uses development API endpoints (default)
 */

// Determine which API environment to use
const API_ENV = process.env.REACT_APP_API_ENV || 'development';

// Configuration object based on API_ENV
const config = API_ENV === 'production'
	? {
		// Production configuration
		API_BASE: "https://api.dokiv.com/v1",
		FORM_API_BASE: "https://api.dokiv.com/v1",
		APP_URL: "https://app.dokiv.com",
		PORTAL_URL: "https://portal.app.dokiv.com",
		APP_ID: "3f49d195-e061-49ea-9ba8-987ded37c9e9"
	}
	: {
		// Development configuration (default)
		API_BASE: "https://api.devnew.dokiv.se/v1",
		FORM_API_BASE: "https://api.devnew.dokiv.se/v1",
		APP_URL: "https://app.devnew.dokiv.se",
		PORTAL_URL: "https://portal.devnew.dokiv.se",
		APP_ID: "3f49d195-e061-49ea-9ba8-987ded37c9e9"
	};

// Log which configuration is being used
console.log(`Using ${API_ENV} API configuration`);
console.log(`API_BASE: ${config.API_BASE}`);

module.exports = config;